import { useCallback, useEffect, useMemo } from "react"
import TableHeader from "../Components/TableHeader"
import core from "../core";
import { Download } from "react-bootstrap-icons";
import TableLoader from "../Components/TableLoader";
import TableFoot from "../Components/TableFoot";
import useNotify from "../hooks/useNotify";
import useListData from "../hooks/useListData";
import useTableFilter from "../hooks/useTableFilter";
import useSortOptions from "../hooks/useSortOptions";

const ActionsHistory = ({ setNotification }) => {
    const notify = useNotify(setNotification);
    const { filter, setFilter, clampPage } = useTableFilter({
        page: 1, limit: 10, keyword: "", sort_by: "id", sort_order: "DESC",
        auction: "", admin: "", start_date: "", end_date: "",
    });

    const sortBy = useSortOptions("bids-sort-by", notify);
    const onListError = useCallback((err) => notify.error(err), [notify]);
    const { data: history, total, loading } = useListData("/actions-history", filter, { onError: onListError });

    const pageCount = useMemo(() => Math.max(1, Math.ceil(total / filter.limit)), [total, filter.limit]);
    useEffect(() => { clampPage(total); }, [total, clampPage]);

    return (
        <div className="page-content-container">
            <h2 className="page-title">Actions History</h2>
            <TableHeader
                setNotification={setNotification}
                filter={filter}
                withoutAddNew={true}
                AddNewButtonIcon={Download}
                sortBy={sortBy}
                exportButton={false}
                checkboxes={[]}
                setFilter={setFilter}
            />
            <div className="table-scroll">
                <table className="responsive-d-table">
                    <thead>
                        <tr>
                            <th>Lot</th>
                            <th>Username</th>
                            <th>Bidder</th>
                            <th>Date</th>
                            <th>IP Address</th>
                            <th>Auction</th>
                            <th>Action Type</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(!loading && history.length > 0) && history.map((row, id) => (
                            <tr key={row.id} className={(id + 2) % 2 === 0 ? "even-row" : "odd-row"}>
                                <td>{row.lot}</td>
                                <td>{row.username}</td>
                                <td>{row.bidder}</td>
                                <td>{core.formdatDate(new Date(row.action_date), "yyyy-mm-dd hr:min:sec")}</td>
                                <td>{row.ip_address}</td>
                                <td>{row.auction}</td>
                                <td>{row.action_type}</td>
                            </tr>
                        ))}
                        {(!loading && history.length === 0) && <tr className="empty-row">
                            <td colSpan={7}><div className="empty-records"><span>Records not found</span></div></td>
                        </tr>}
                        {loading && <TableLoader colspan={7} />}
                    </tbody>
                </table>
            </div>
            <TableFoot filter={filter} setFilter={setFilter} count={pageCount} total={total} />
        </div>
    )
}

export default ActionsHistory
